import { Reveal } from "@/components/Reveal";
import { WhatsAppButton } from "@/components/CTAButtons";
import { IMAGES } from "@/data/site";

const SHOTS = [
  { src: IMAGES.highwayRescue, span: "md:col-span-2 md:row-span-2" },
  { src: IMAGES.work4, span: "md:col-span-2 md:row-span-1" },
  { src: IMAGES.work5, span: "md:col-span-2 md:row-span-1" },
  { src: IMAGES.work6, span: "md:col-span-2 md:row-span-1" },
  { src: IMAGES.work1, span: "md:col-span-2 md:row-span-1" },
  { src: IMAGES.work7, span: "md:col-span-2 md:row-span-1" },
  { src: IMAGES.cattleTrailer, span: "md:col-span-2 md:row-span-1" },
  { src: IMAGES.work2, span: "md:col-span-1 md:row-span-1" },
  { src: IMAGES.work3, span: "md:col-span-1 md:row-span-1" },
  { src: IMAGES.heroFleet, span: "md:col-span-1 md:row-span-1" },
  { src: IMAGES.fleetDirtLot, span: "md:col-span-1 md:row-span-1" },
];

export default function Gallery() {
  return (
    <section id="galeria" className="bg-brand-obsidian py-24 md:py-32 grain" data-testid="gallery">
      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-red">Portfólio</p>
          <h2 className="mt-4 font-display text-4xl uppercase leading-[0.95] tracking-tight text-white md:text-6xl">
            Serviços realizados
          </h2>
        </Reveal>

        <div className="grid auto-rows-[200px] grid-flow-row-dense grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4">
          {SHOTS.map((s, i) => (
            <Reveal key={i} delay={(i % 4) * 0.06} className={s.span}>
              <div className="group h-full w-full overflow-hidden rounded-sm border border-white/10">
                <img
                  src={s.src}
                  alt=""
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                />
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12 flex justify-center">
          <WhatsAppButton testid="gallery-whatsapp" />
        </Reveal>
      </div>
    </section>
  );
}
